import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Form, Button, Spinner } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import { FormField, SelectFormField } from "../../../utils/FormFields";
import { AccountStatus } from "../../../utils";

const canSubmit = (ra) => ra.RelatedAccountName && ra.RelatedAccountNumber && ra.RelatedAccountStatus;

const ModalRelatedAccount = ({ open, relatedAccount, toggle, saving, onSave, onChange, banks }) => (
  <Modal isOpen={open} toggle={toggle}>
    <ModalHeader toggle={toggle}>Related Account</ModalHeader>
    <ModalBody>
      <Form>
        <FormField
          label="Name: "
          name="RelatedAccountName"
          onChange={onChange}
          value={relatedAccount.RelatedAccountName}
        />
        <FormField
          label="Number: "
          name="RelatedAccountNumber"
          onChange={onChange}
          value={relatedAccount.RelatedAccountNumber}
        />
        {banks ? (
          <SelectFormField
            label="Custody: "
            name="CustodianEntityId"
            onChange={onChange}
            value={relatedAccount.CustodianEntityId}
            selectItems={[{ Id: "", Name: "" }].concat(banks)}
            getSelectItemId={(i) => i.Id}
            getSelectItemName={(i) => i.Name}
          />
        ) : (
          <Spinner size="sm" />
        )}
        <SelectFormField
          label="Status: "
          name="RelatedAccountStatus"
          onChange={onChange}
          value={relatedAccount.RelatedAccountStatus}
          selectItems={Object.values(AccountStatus)}
          getSelectItemId={(i) => i}
          getSelectItemName={(i) => i}
        />
      </Form>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={toggle}>
        Cancel
      </Button>
      <LaddaButton
        className="btn btn-ladda btn-primary"
        loading={saving}
        disabled={!canSubmit(relatedAccount)}
        onClick={onSave}
        data-style={EXPAND_RIGHT}
      >
        {saving ? " Saving" : " Save"}
      </LaddaButton>
    </ModalFooter>
  </Modal>
);

ModalRelatedAccount.propTypes = {
  open: PropTypes.bool.isRequired,
  relatedAccount: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  banks: PropTypes.array,
};

ModalRelatedAccount.defaultProps = {
  banks: undefined,
};

export default ModalRelatedAccount;
